import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { SaveTrayInspectionRequest, TrayInspectionInfo } from 'api/models/Trays';
import { invalidateQueryKeys } from 'utils/invalidateQueryKeys';

export const useUpdateTrayInspection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ trayId, inspectionInfo }: { trayId: string; inspectionInfo: TrayInspectionInfo }) => {
      // the modelling is slightly different between request and response, need to remap
      const payload: SaveTrayInspectionRequest = {
        trayInspection: {
          allClean: inspectionInfo.allClean,
          allFunctional: inspectionInfo.allFunctional,
          allPartsPresent: inspectionInfo.allPartsPresent,
          trayUsed: inspectionInfo.trayUsed,
          missingParts: inspectionInfo.missingParts,
          missingPartsComment: inspectionInfo.missingPartsComment,
        },
        status: inspectionInfo.status,
        comments: inspectionInfo.comments,
        gsImagePath: inspectionInfo.gsImagePath,
        decantGsImagePath: inspectionInfo.decantGsImagePath,
        trayReference: inspectionInfo.trayReference,
        stage: inspectionInfo.stage,
        decantedTrays: inspectionInfo.decantedTrays,
      };

      return await API.deliveries.updateTrayInspection({
        trayId,
        inspection: payload,
      });
    },
    onSuccess: () =>
      invalidateQueryKeys({
        queryClient,
        queryKeys: [
          QueryKeys.Delivery,
          QueryKeys.Deliveries,
          QueryKeys.Order,
          QueryKeys.TrayCapturePrintOut,
          QueryKeys.TimeStamps,
          QueryKeys.SurgeryTimeStamps,
        ],
      }),
  });
};
